import { render, staticRenderFns } from "./Reorganize.vue?vue&type=template&id=60a20496&"
import script from "./Reorganize.vue?vue&type=script&lang=js&"
export * from "./Reorganize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports